import { Box, makeStyles } from "@material-ui/core";
import React, { Fragment } from "react";
import ItemButton from "../components/ItemButton";
import titleButtonData from "../veggies/TitleButtonData";

const useStyles = makeStyles((theme) => ({
  mobileContainer: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      width: "100%",
      height: "auto",
      //   backgroundColor: theme.palette.primary.main,
    },
  },
}));

export default function MobileItem(props) {
  const { veggieItem, setVeggieItem, vegData } = props;
  //   const [sub, setSub] = useState(false);

  const classes = useStyles();

  return (
    <Box className={classes.mobileContainer}>
      {titleButtonData.map((item) => (
        <Fragment key={item._id}>
          <ItemButton
            button={veggieItem}
            id={item._id}
            title={item._id}
            setButton={() => setVeggieItem(item._id, item._id)}
            vegData={vegData}
          />
        </Fragment>
      ))}
    </Box>
  );
}
